/**
 * @generated SignedSource<<f54d95893611ccf73c87633a2ada7495>>
 * @relayHash 7e9a3b7bc844d1ec4fb559b84add4cb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7d9e578e9ba33fb985edfb4b958f4947985bf9d7c2c8e5a724a31013b41d04b1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useVersionsRefetchQuery$variables = {
  boardId: string;
  jiraProjectIds: ReadonlyArray<string>;
};
export type useVersionsRefetchQuery$data = {
  readonly jira: {
    readonly versionsForProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly versionId: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"versionPanel_softwareVersionBacklogPanelRelay_jiraVersionEdges">;
      } | null | undefined> | null | undefined;
    };
  } | null | undefined;
};
export type useVersionsRefetchQuery = {
  response: useVersionsRefetchQuery$data;
  variables: useVersionsRefetchQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": isVisualRefreshEAPEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider: {
    readonly get: () => boolean;
  };
});

import isVisualRefreshEAPEnabled_provider from '@atlassian/jira-relay-provider/src/visual-refresh-eap-2.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraProjectIds"
},
v2 = {
  "kind": "Literal",
  "name": "filter",
  "value": [
    "UNRELEASED"
  ]
},
v3 = {
  "kind": "Variable",
  "name": "jiraProjectIds",
  "variableName": "jiraProjectIds"
},
v4 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v7 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v8 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  },
  (v3/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useVersionsRefetchQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "versionsForProjects",
              "args": [
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "concreteType": "JiraVersionConnection",
              "kind": "LinkedField",
              "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraVersionEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "versionPanel_softwareVersionBacklogPanelRelay_jiraVersionEdges"
                    },
                    {
                      "concreteType": "JiraVersion",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v4/*: any*/),
                        (v5/*: any*/)
                      ]
                    },
                    (v6/*: any*/)
                  ]
                },
                (v7/*: any*/)
              ]
            },
            "action": "THROW",
            "path": "jira.versionsForProjects"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useVersionsRefetchQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "releaseDate"
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "boardId",
                            "variableName": "boardId"
                          }
                        ],
                        "concreteType": "JiraVersionStatistics",
                        "kind": "LinkedField",
                        "name": "statistics",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "doneEstimate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "totalEstimate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "percentageCompleted"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "notEstimated"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "done"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "totalIssueCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "toDo"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "inProgress"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          (v10/*: any*/),
                          {
                            "alias": "editProjectConfig",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                              }
                            ],
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canPerform"
                              }
                            ],
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                          }
                        ]
                      },
                      (v10/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              (v7/*: any*/)
            ]
          },
          {
            "args": (v8/*: any*/),
            "filters": [
              "jiraProjectIds",
              "filter"
            ],
            "handle": "connection",
            "key": "versionBacklogPanelRelay_versionsForProjects",
            "kind": "LinkedHandle",
            "name": "versionsForProjects"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7d9e578e9ba33fb985edfb4b958f4947985bf9d7c2c8e5a724a31013b41d04b1",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProjects"
          ]
        }
      ]
    },
    "name": "useVersionsRefetchQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": isVisualRefreshEAPEnabled_provider
    }
  }
};
})();

(node as any).hash = "49947aa3f8615f5dcdee393f6d3fd187";

export default node;
